import { c as _c } from "react/compiler-runtime";
import { DateTimePicker, Modal, PrimaryButton, getDate, toISOStringWithoutTimezone, transformDateToSeconds } from '@systemeio/ui';
import { BookingDetailsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { BookingViewInterface } from 'modules/calendar/bookings/types/bookings-interface';
import { useTimeSlots } from 'modules/calendar/events/hooks/use-time-slots';
import { TimeSlot, TimeSlotsFilterInterface } from 'modules/calendar/events/types/calendar-filter-interface';
import { getDateOnly, getMonthStartEndDates } from 'modules/calendar/utils/date-time-formatters';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { twMerge } from 'tailwind-merge';
import { EventTypeEnum } from '../../events/enums/event-type-enum';
interface RescheduleBookingProps {
  booking: BookingViewInterface | BookingDetailsInterface;
  opened: boolean;
  onClose: () => void;
  onRescheduleBooking: (date: string, booking?: BookingViewInterface) => Promise<void>;
  bookingId: number;
  eventType?: EventTypeEnum;
}
export const RescheduleBookingModal = t0 => {
  const $ = _c(55);
  const {
    booking,
    onClose,
    opened,
    onRescheduleBooking,
    bookingId,
    eventType: t1
  } = t0;
  const eventType = t1 === undefined ? EventTypeEnum.Individual : t1;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const [date, setDate] = useState(null);
  const t2 = booking.eventId;
  let t3;
  if ($[0] !== booking.date) {
    t3 = getMonthStartEndDates(getDate(booking.date));
    $[0] = booking.date;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== booking.eventId || $[3] !== t3) {
    t4 = {
      eventId: t2,
      dateRange: t3
    };
    $[2] = booking.eventId;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [filter, setFilter] = useState(t4);
  let t5;
  if ($[5] !== bookingId || $[6] !== eventType || $[7] !== filter || $[8] !== opened) {
    t5 = {
      filter,
      eventType,
      bookingIdToBeRescheduled: bookingId,
      opened
    };
    $[5] = bookingId;
    $[6] = eventType;
    $[7] = filter;
    $[8] = opened;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    slots,
    isLoading
  } = useTimeSlots(t5);
  let t6;
  if ($[10] !== slots) {
    t6 = slots.map(_temp);
    $[10] = slots;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const dateSlots = t6;
  let t7;
  if ($[12] !== booking || $[13] !== date || $[14] !== onClose || $[15] !== onRescheduleBooking) {
    t7 = async () => {
      if (!date) {
        return;
      }
      const bookingToPass = "id" in booking ? booking : undefined;
      await onRescheduleBooking(date, bookingToPass as BookingViewInterface | undefined);
      onClose();
    };
    $[12] = booking;
    $[13] = date;
    $[14] = onClose;
    $[15] = onRescheduleBooking;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const rescheduleBooking = t7;
  let t8;
  if ($[17] !== t) {
    t8 = t("dashboard.bookings.actions.reschedule_booking");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = booking.date;
  const t10 = isLoading && "after:block after:content-[\"\"] after:absolute after:left-0 after:right-0 after:top-0 after:bottom-0\n            before:w-12 before:h-12 before:border-4 before:border-brand-primary before:border-b-transparent before:rounded-full\n            before:absolute before:top-[35%] before:left-[40%] before:animate-spin";
  let t11;
  if ($[19] !== t10) {
    t11 = twMerge("relative", t10);
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = date_0 => {
      setFilter(prev => ({
        ...prev,
        dateRange: getMonthStartEndDates(date_0)
      }));
    };
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== dateSlots || $[23] !== slots) {
    t13 = date_1 => filterTime(date_1, slots, dateSlots);
    $[22] = dateSlots;
    $[23] = slots;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== dateSlots) {
    t14 = date_2 => dateSlots.includes(getDateOnly(toISOStringWithoutTimezone(date_2)));
    $[25] = dateSlots;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t11 || $[28] !== t13 || $[29] !== t14) {
    t15 = {
      timeIntervals: 1,
      calendarClassName: t11,
      timeClassName: _temp2,
      onMonthChange: t12,
      filterTime: t13,
      filterDate: t14
    };
    $[27] = t11;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = val => {
      if (val) {
        setDate(val);
      }
    };
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const t17 = user?.createdAt;
  const t18 = user?.timezone;
  const t19 = user?.dateFormat;
  const t20 = user?.timeFormat;
  let t21;
  if ($[32] !== booking.date || $[33] !== intlLocale || $[34] !== t15 || $[35] !== t17 || $[36] !== t18 || $[37] !== t19 || $[38] !== t20) {
    t21 = <DateTimePicker value={t9} customProps={t15} onChange={t16} createdAt={t17} timezone={t18} userDateFormat={t19} userTimeFormat={t20} intlLocale={intlLocale} />;
    $[32] = booking.date;
    $[33] = intlLocale;
    $[34] = t15;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== rescheduleBooking) {
    t22 = () => rescheduleBooking();
    $[40] = rescheduleBooking;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t) {
    t23 = t("dashboard.bookings.actions.reschedule_booking");
    $[42] = t;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t22 || $[45] !== t23) {
    t24 = <div className="flex justify-center"><PrimaryButton onClick={t22}>{t23}</PrimaryButton></div>;
    $[44] = t22;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t21 || $[48] !== t24) {
    t25 = <div className="flex flex-col gap-3">{t21}{t24}</div>;
    $[47] = t21;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== onClose || $[51] !== opened || $[52] !== t25 || $[53] !== t8) {
    t26 = <Modal opened={opened} title={t8} onClose={onClose}>{t25}</Modal>;
    $[50] = onClose;
    $[51] = opened;
    $[52] = t25;
    $[53] = t8;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  return t26;
};
function filterTime(dateAndTime: Date, slots: TimeSlot[], dateSlots: string[]) {
  const date = getDateOnly(toISOStringWithoutTimezone(dateAndTime));
  const time = transformDateToSeconds(dateAndTime);
  const timeSlots = slots.find(slot => getDateOnly(slot.date) === date)?.spots || [];
  return dateSlots.includes(date) && timeSlots.some(({
    startTime
  }) => startTime === time);
}
function _temp(x) {
  return getDateOnly(x.date);
}
function _temp2() {
  return "aria-disabled:hidden";
}